import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import {
  BanListQuery,
  ExportFormat,
  IBanInfoApi,
  UserBanLogQuery,
  UserBanPostsQuery,
} from './types';

const compactParams = (
  params?: object,
): Record<string, unknown> | undefined => {
  if (!params) return undefined;

  return Object.entries(params).reduce(
    (acc, [key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        (acc as Record<string, unknown>)[key] = value;
      }
      return acc;
    },
    {} as Record<string, unknown>,
  );
};

const getExport = (
  url: string,
  params: BanListQuery,
  format: ExportFormat,
): Promise<Blob> =>
  http
    .get(url, {
      params: compactParams({ ...params, format }),
      responseType: 'blob',
    })
    .then((response) => response.data);

export const banInfo: IBanInfoApi = {
  getBannedUsers: (params?: BanListQuery) =>
    http
      .get(endpoint.banInfo.BANNED_USERS, { params: compactParams(params) })
      .then((response) => response.data),

  getBannedGroups: (params?: BanListQuery) =>
    http
      .get(endpoint.banInfo.BANNED_GROUPS, { params: compactParams(params) })
      .then((response) => response.data),

  getBannedChannels: (params?: BanListQuery) =>
    http
      .get(endpoint.banInfo.BANNED_CHANNELS, { params: compactParams(params) })
      .then((response) => response.data),

  exportBannedUsers: (params, format) =>
    getExport(endpoint.banInfo.BANNED_USERS, params, format),

  exportBannedGroups: (params, format) =>
    getExport(endpoint.banInfo.BANNED_GROUPS, params, format),

  exportBannedChannels: (params, format) =>
    getExport(endpoint.banInfo.BANNED_CHANNELS, params, format),

  getCounters: () =>
    http.get(endpoint.banInfo.COUNTERS).then((response) => response.data),

  getReasons: (type) =>
    http
      .get(endpoint.banInfo.REASONS, { params: { type } })
      .then((response) => response.data),

  getLog: (id) =>
    http.get(endpoint.banInfo.LOG(id)).then((response) => response.data),

  getMedia: (id) =>
    http
      .get(endpoint.banInfo.MEDIA(id), { responseType: 'blob' })
      .then((response) => response.data),

  getPost: (id) =>
    http.get(endpoint.banInfo.POST(id)).then((response) => response.data),

  getUser: (userId) =>
    http.get(endpoint.banInfo.USER(userId)).then((response) => response.data),

  getGroup: (groupId) =>
    http.get(endpoint.banInfo.GROUP(groupId)).then((response) => response.data),

  getChannel: (channelId) =>
    http
      .get(endpoint.banInfo.CHANNEL(channelId))
      .then((response) => response.data),

  getUserLog: (userId, params?: UserBanLogQuery) =>
    http
      .get(endpoint.banInfo.USER_LOG(userId), { params: compactParams(params) })
      .then((response) => response.data),

  getUserPosts: (userId, params?: UserBanPostsQuery) =>
    http
      .get(endpoint.banInfo.USER_POSTS(userId), {
        params: compactParams(params),
      })
      .then((response) => response.data),
};
